import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, DrillIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-green-900" data-id="element-119" data-mp="s9zypgcqn4m7">
      <div className="h-1.5 w-full bg-amber-500" aria-hidden="true" data-id="element-120" data-mp="ncq29gqxlsov" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-121" data-mp="nekqb3xi20x6">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-amber-400/50 bg-green-950/60 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-122" data-mp="3cz5to748dry8">
          <DrillIcon className="h-4 w-4" aria-hidden="true" data-id="element-123" data-mp="399bctsb4jly3" /> {productShortName}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.08] text-stone-50 sm:text-5xl lg:text-6xl" data-id="element-124" data-mp="3e84odf6up2vm">
          Master your year of Drilling &amp; Well Engineering education
          <br data-id="element-125" data-mp="2vjpywwc6lwwx" />
          <span className="text-amber-400" data-id="element-126" data-mp="2vjga3c2vhvst">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-127" data-mp="2hkghjtc8owrd">
          <img src={productImage} alt="Drilling & Well Engineering Teacher Ready: nine volumes and five bonus resources covering fundamentals, well planning, drilling rigs, drilling fluids, casing and cementing, completion and production, well control, troubleshooting, and teaching" className="mx-auto w-full drop-shadow-2xl" data-id="element-128" data-mp="nbbdp0t5cf6c" />
        </motion.div>

        <div className="mt-9" data-id="element-129" data-mp="161t2iuauyqmf">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-130" data-mp="161jc55lwihg7">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-stone-50" data-id="element-131" data-mp="114ssy9esv5qk">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-stone-50/15 bg-green-950/50 px-3 py-2" data-id="element-132" data-mp="3lu02l0av52z7">
              <Icon className="h-3.5 w-3.5 text-amber-400" aria-hidden="true" data-id="element-133" data-mp="1x9ukg9uwtbmw" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-green-100/80" data-id="element-134" data-mp="21b63fwja2ym4">
          Created by drilling and well engineering education specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}